import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const SpeakerIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M8 11.5C8.55229 11.5 9 11.0523 9 10.5C9 9.94771 8.55229 9.5 8 9.5C7.44772 9.5 7 9.94771 7 10.5C7 11.0523 7.44772 11.5 8 11.5Z"
		></path>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M3.16349 1.81901C3 2.13988 3 2.55992 3 3.4V12.6C3 13.4401 3 13.8601 3.16349 14.181C3.3073 14.4632 3.53677 14.6927 3.81901 14.8365C4.13988 15 4.55992 15 5.4 15H10.6C11.4401 15 11.8601 15 12.181 14.8365C12.4632 14.6927 12.6927 14.4632 12.8365 14.181C13 13.8601 13 13.4401 13 12.6V3.4C13 2.55992 13 2.13988 12.8365 1.81901C12.6927 1.53677 12.4632 1.3073 12.181 1.16349C11.8601 1 11.4401 1 10.6 1H5.4C4.55992 1 4.13988 1 3.81901 1.16349C3.53677 1.3073 3.3073 1.53677 3.16349 1.81901ZM8 13.5C9.65685 13.5 11 12.1569 11 10.5C11 8.84315 9.65685 7.5 8 7.5C6.34315 7.5 5 8.84315 5 10.5C5 12.1569 6.34315 13.5 8 13.5ZM9.5 4C9.5 4.82843 8.82843 5.5 8 5.5C7.17157 5.5 6.5 4.82843 6.5 4C6.5 3.17157 7.17157 2.5 8 2.5C8.82843 2.5 9.5 3.17157 9.5 4Z"
		></path>
	</svg>
))
